import { Device } from 'DeviceUtils';
import { StyleSheet } from 'react-native';
import Theme, { fontStyles } from 'Theme';

const defaultStyles = StyleSheet.create({
    container: {
        backgroundColor: 'rgba(0, 0, 0, 0.95)',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
        paddingHorizontal: 20
    },
    title: {
        ...fontStyles.title,
        color: 'white',
        textAlign: 'center',
        alignSelf: 'center',
        paddingHorizontal: 35
    },
    hrStyle: {
        width: Device.isTablet ? '40%' : '80%',
        marginVertical: 20,
        alignSelf: 'center'
    },
    subtitle: {
        ...fontStyles.subtitle,
        color: 'white',
        maxWidth: Device.isTabletOrWeb ? '70%' : '80%',
        marginBottom: 36,
        textAlign: 'center'
    },
    buttonContainer: {
        width: Device.isTabletOrWeb ? '50%' : '90%',
        justifyContent: 'center',
        alignItems: 'center'
    },
    button: {
        marginVertical: 10,
        marginHorizontal: Device.isTabletOrWeb ? 10 : 0,
        minWidth: '20%'
    },
    buttonContinue: {
        marginVertical: 10,
        marginHorizontal: Device.isTabletOrWeb ? 10 : 0,
        minWidth: '20%',
        textAlign: 'center'
    },
    textContinue: {
        fontSize: Device.isAndroid ? Theme.fontSizes.button - 4 : Theme.fontSizes.button
    },
    logoBox: {
        alignItems: 'center',
        paddingTop: 24
    },
    logo: {
        alignSelf: 'center',
        justifyContent: 'center',
        width: 189.91,
        height: 50.64,
        marginBottom: 40
    },
    imageBackground: {
        flex: 1,
        justifyContent: 'center'
    },
    iconCloseContainer: {
        marginTop: 17,
        right: 25,
        paddingHorizontal: 0,
        alignItems: 'flex-end'
    },
    scrollContainer: {
        flexGrow: 1,
        justifyContent: 'center',
        alignItems: 'center'
    }
});

export default defaultStyles;
